import {DEFAULTS} from '../../index.js';

/**
 * Abstract Hypercube.js mesh.
 * @example
 * class MeshExample extends Mesh {}
 */
class Mesh {

    /**
     * Stores the indices.
     * @type {number[]}
     * @protected
     */
    $indices;

    /**
     * Stores the material.
     * @type {import('../../index.js').Material}
     * @protected
     */
    $material;

    /**
     * Stores the name.
     * @type {string}
     * @protected
     */
    $name;

    /**
     * Stores the normals.
     * @type {number[]}
     * @protected
     */
    $normals;

    /**
     * Stores the positions.
     * @type {number[]}
     * @protected
     */
    $positions;

    /**
     * Stores the shadow casting status.
     * @type {boolean}
     * @protected
     */
    $shadowcasting;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type;

    /**
     * Gets the indices.
     * @type {number[]}
     * @public
     * @readonly
     */
    get indices() {

        return this.$indices;
    };

    /**
     * Gets the material.
     * @type {import('../../index.js').Material}
     * @public
     * @readonly
     */
    get material() {

        return this.$material;
    }

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Gets the normals.
     * @type {number[]}
     * @public
     * @readonly
     */
    get normals() {

        return this.$normals;
    };

    /**
     * Gets the positions.
     * @type {number[]}
     * @public
     * @readonly
     */
    get positions() {

        return this.$positions;
    };

    /**
     * Gets the shadowcasting status.
     * @type {boolean}
     * @public
     * @readonly
     */
    get shadowcasting() {

        return this.$shadowcasting;
    };

    /**
     * Gets the type.
     * @type {string}
     * @public
     * @readonly
     */
    get type() {

        return this.$type;
    };

    /**
     * Creates a new Hypercube.js mesh.
     * @param {string} [$name] The name of the mesh to create.
     */
    constructor($name = 'Mesh') {

        this.$name = $name;

        this.$material = DEFAULTS.material();
        this.$shadowcasting = true;
    }

    /**
     * Sets the material.
     * @param {import('../../index.js').Material} $material The material to add.
     * @public
     */
    setmaterial($material) {

        this.$material = $material;
    }

    /**
     * Sets the shadow casting status.
     * @param {boolean} $shadowcasting The shadow casting status to set.
     * @public
     */
    setshadowcasting($shadowcasting) {

        this.$shadowcasting = $shadowcasting;
    }
}

export {

    Mesh
};

export default Mesh;
